import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { getQueueNFE } from "../actions";

// Type for a single queue NFE item
export type TQueueNFEItem = {
  uuid: string;
  cnpj: string;
  access_key: string;
  has_error: boolean;
  reason: string;
  created_at: string;
  updated_at: string;
};

// Type for the queue NFE state
export type TQueueNFEState = {
  count: number;
  errorsCount: number;
  next: string | null;
  previous: string | null;
  results: TQueueNFEItem[];
};

// Initial state for queueNFE
const initialQueueNFEState: TQueueNFEState = {
  count: 0,
  errorsCount: 0,
  next: null,
  previous: null,
  results: [],
};
export interface AccessKeyImportState {
  accessKeys: string[];
  errors: boolean[];
  queueNFE: TQueueNFEState;
  loading: boolean;
}

const initialState: AccessKeyImportState = {
  accessKeys: [],
  errors: [],
  queueNFE: initialQueueNFEState,
  loading: true,
};

const accessKeyImportSlice = createSlice({
  name: "accessKeyImport",
  initialState,
  reducers: {
    setAccessKeysState(state, action: PayloadAction<string[]>) {
      state.accessKeys = action.payload;
    },
    setAccessKeyErrorsState(state, action: PayloadAction<boolean[]>) {
      state.errors = action.payload;
    },
    setQueueNFEState(state, action: PayloadAction<TQueueNFEState>) {
      state.queueNFE = action.payload;
    },
    resetAccessKeysState(state) {
      state.accessKeys = [];
      state.errors = [];
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getQueueNFE.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getQueueNFE.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(getQueueNFE.rejected, (state) => {
      state.loading = false;
    });
  },
});

export const {
  setAccessKeysState,
  setAccessKeyErrorsState,
  resetAccessKeysState,
  setQueueNFEState,
} = accessKeyImportSlice.actions;
export default accessKeyImportSlice.reducer;
